const data=[
    {
        id:1,
        name:'The Forbidden City',
        describe:"The video show some of palaces of the Forbidden City. And also the four seasons of the Forbidden City.",
        converImg: "Builiding.jpg",
    },
    {
        id:2,
        name:'Youth Justice center VR application',
        describe:"A VR application to show people who want to apply for a job as a youth justice officer a full day's work process to consider whether the job is right for them.",
        converImg: "center.jpg",
    },
    {
        id:3,
        name:'Tenzies Game',
        describe:"This game is suitable for early childhood. They can use the game to identify numbers.",
        converImg: "game.jpeg",
    },
]
export default data;